export const AddressFragment = gql`
  fragment AddressFragment on Address {
    addressLine1
    addressLine2
    city
    state
    zip
  }
`
